import styled from "styled-components";

export const NavigationAndDiscountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & .WebDiscountInfo {
    align-items: center;
    display: flex;
    height: 40px;
  }

  & + * {
    margin-top: ${({ theme }) => theme.spacing.lg};
  }

  @media screen and (min-width: 483px) {
    flex-direction: row;

    & .WebDiscountInfo {
      order: 2;
      width: 100%;
    }

    & .NavigationButtons {
      order: 1;
      width: 100%;
    }
  }
`;

export const WebDiscountInfo = styled.div`
  font-weight: 600;
`;
